
import React, { useState } from 'react';
import Button from '../base/Button';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const openZalo = () => {
    window.open('https://zalo.me/0961686191', '_blank');
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/b926f7d0924bb0e3f89c26c6bb5d4789/1c6105491001bfc8dc05ae63b20021b7.png" 
              alt="Minh Khôi Laundry Logo" 
              className="h-14 w-auto mr-3"
            />
            <div>
              <h1 className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
                Minh Khôi
              </h1>
              <p className="text-sm text-gray-600">Laundry</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Trang chủ
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Giới thiệu
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Dịch vụ
            </button>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Bảng giá
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Hình ảnh
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Liên hệ
            </button>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Button 
              variant="outline" 
              size="sm"
              onClick={openZalo}
              className="text-green-600 border-green-600 hover:bg-green-50"
            >
              <i className="ri-message-3-line mr-2"></i>
              Zalo
            </Button>
            <Button 
              variant="primary" 
              size="sm"
              onClick={() => scrollToSection('booking')}
            >
              <i className="ri-calendar-check-line mr-2"></i>
              Đặt lịch
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('hero')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Trang chủ
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Giới thiệu
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Dịch vụ
              </button>
              <button 
                onClick={() => scrollToSection('pricing')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Bảng giá
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Hình ảnh
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-blue-600 transition-colors text-left cursor-pointer"
              >
                Liên hệ
              </button>
              
              <div className="flex flex-col space-y-2 pt-4">
                <Button 
                  variant="outline" 
                  size="sm"
                  onClick={openZalo}
                  className="text-green-600 border-green-600 hover:bg-green-50 w-full"
                >
                  <i className="ri-message-3-line mr-2"></i>
                  Chat Zalo
                </Button>
                <Button 
                  variant="primary" 
                  size="sm"
                  onClick={() => scrollToSection('booking')}
                  className="w-full"
                >
                  <i className="ri-calendar-check-line mr-2"></i>
                  Đặt lịch ngay
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
